<template>
  <div>
    <b-card bg-variant="light" body-class="text-center py-1">
      <b-row>
        <b-col class="px-1 py-1" cols="12" md="2">
          <b-card
            bg-variant="secondary"
            body-class="px-1 d-flex flex-row flex-sm-row flex-md-column justify-content-center align-items-center py-1"
            text-variant="white"
          >
            <small class="mr-1">ส่วนแบ่งรายได้</small>
            <span class="text-warning">{{ results.sharePercent }}%</span>
          </b-card>
        </b-col>
        <b-col class="px-1 py-1" cols="6" md="2">
          <b-card bg-variant="default" body-class="py-1">
            <small>รายได้ทั้งหมด</small>
            <div class="text-primary">฿ {{ results.totalIncome }}</div>
          </b-card>
        </b-col>
        <b-col class="px-1 py-1" cols="6" md="2">
          <b-card bg-variant="default" body-class="py-1">
            <small>รายได้ปัจจุบัน</small>
            <div class="text-success">฿ {{ results.currentIncome }}</div>
          </b-card>
        </b-col>
        <b-col class="px-1 py-1" cols="4" md="2">
          <b-card bg-variant="default" body-class="py-1 px-0">
            <small>สมาชิกแนะนำ</small>
            <div class="text-info">{{ results.memberReferCount }}</div>
          </b-card>
        </b-col>
        <b-col class="px-1 py-1" cols="4" md="2">
          <b-card bg-variant="default" body-class="py-1 px-0">
            <small>แทงทั้งหมด</small>
            <div class="text-info">฿ {{ results.referTransactionAmount }}</div>
          </b-card>
        </b-col>
        <b-col class="px-1 py-1" cols="4" md="2">
          <b-card bg-variant="default" body-class="py-1 px-0">
            <small>คลิกทั้งหมด</small>
            <div class="text-info">{{ results.memberReferClick }}</div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <!-- <h4 class="mt-4 font-weight-bold text-secondary">
      <i class="fas fa-share-alt-square"></i> ลิ้งค์แนะนำ และแบนเนอร์
    </h4> -->
    <b-card header-tag="header">
      <template #header>
        <h5 class="mb-0 font-weight-bold text-secondary"><i class="fas fa-share-alt-square"></i> ลิ้งค์สำหรับโปรโมท</h5>
      </template>
      <b-input readonly class="text-center mb-2" v-model="results.memberReferUrl" />
      <button
        type="submit"
        class="btn golden-btn btn-block mb-2"
        v-clipboard:copy="results.memberReferUrl"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        คัดลอกลิงค์แนะนำ
        <i class="fas fa-copy"></i>
      </button>
      <b-row>
        <b-col cols="6" class="pr-1">
          <a rel="nofollow" :href="'http://www.facebook.com/share.php?u=' + results.memberReferUrl" @click="fbsClick" target="_blank" class="btn btn-block mb-2 btn-primary">
            <i class="fab fa-facebook"></i> แชร์ไปเฟซบุ๊ค
            </a>
        </b-col>
        <b-col cols="6" class="pb-1">
          <a rel="nofollow" :href="'https://social-plugins.line.me/lineit/share?url=' + results.memberReferUrl" @click="lineClick" target="_blank" class="btn btn-block mb-2 btn-success">
            <i class="fab fa-line"></i> แชร์ไปไลน์
          </a>
        </b-col>
        <b-col cols="6"></b-col>
      </b-row>
      <b-alert
        show
        variant="danger"
        class="d-flex flex-column flex-sm-column flex-md-row justify-content-between align-items-center"
      >
        <h1 class="mb-0 mr-2">
          <i class="fas fa-exclamation-triangle"></i>
        </h1>
        <div class="m-1 mb-0 text-center text-sm-center text-md-left">
          <b>หมายเหตุ!</b> หากพบปัญหา
          <u>ลิงค์ถูกแบนจาก google,facebook หรือช่องทางอื่นๆ</u> ให้ส่งลิงค์แนะนำเพื่อนของท่าน มายังไลน์
          <a href="https://lin.ee/QG8Yl8H" target="_blank" class="iconmenu">
            https://lin.ee/QG8Yl8H
          </a>
          พร้อมระบุปัญหา สำหรับรับลิงค์ใหม่ในการแนะนำเพื่อน
        </div>
      </b-alert>
    </b-card>
    <h4 class="mt-4 font-weight-bold text-secondary">
      <i class="fas fa-project-diagram"></i> ลิ้งค์ช่วยแชร์ ช่วยแนะนำ
    </h4>
    <b-alert show variant="danger" class="text-center">
      <p>
        <strong>ลิ้งค์ช่วยแชร์รับ 8% ฟรี!</strong>
      </p>
      <p class="mb-0">
        (เพียงก๊อปปี้ลิ้งค์ไปแชร์ก็ได้เงินแล้ว)
        <br />ยิ่งแชร์มากยิ่งได้มาก
      </p>
    </b-alert>
    <p>ท่านสามารถนำลิ้งค์ด้านล่างนี้หรือนำป้ายแบนเนอร์ ไปแชร์ในช่องทางต่างๆ ไม่ว่าจะเป็น เว็บไชต์ส่วนตัว, Blog, Facebook หรือ Social Network อื่นๆ หากมีการสมัครสมาชิกโดยคลิกผ่านลิ้งค์ของท่านเข้ามา ลูกค้าที่สมัครเข้ามาก็จะอยู่ภายให้เครือข่ายของท่านทันที และหากลูกค้าภายใต้เครือข่ายของท่านมีการเดิมพันเข้ามา ทุกยอดการเดิมพัน ท่านจะได้รับส่วนแบ่งในการแนะนำ 8% ทันทีโดยไม่มีเงื่อนไข</p>
    <p>
      <strong>ตัวอย่างดังนี้</strong>
    </p>
    <b-list-group class="mb-4">
      <b-list-group-item>ลูกค้าท่าน 1 คน แทง 1,000 บาท ท่านจะได้ 80 บาท</b-list-group-item>
      <b-list-group-item>ลูกค้าท่าน 10 คน แทง 1,000 บาท ท่านจะได้รับ 800 บาท</b-list-group-item>
      <b-list-group-item>ลูกค้าท่าน 100 คน แทง 1,000 บาท ท่านจะได้รับ 8,000 บาท</b-list-group-item>
    </b-list-group>
    <p>สามารถทำรายได้เดือน 100,000 บาทง่ายๆเลยทีเดียว เพราะทางเรามีหวยเปิดรับทายผลทุกวัน มีมากกว่าวันละ 200 รอบ เปิดรับแทงออนไลน์ตลอด 24 ชม. และรายได้ทุกบาททุกสตางค์ของท่านสามารถตรวจสอบได้ทุกขั้นตอน งานนี้แจกจริง จริงจ่าย ที่นี้ที่เดียวที่ให้คุณมากกว่าใคร ก๊อปปี้ลิ้งค์และข้อความด้านล่างนี้ นำไปแชร์ได้เลย</p>
    <p>
      <strong>หมายเหตุ:</strong> รายได้การช่วยแชร์ช่วยแนะนำของท่านสามารถแจ้งถอนได้ทุกเวลา หากมียอดรายได้มากกว่า 500 บาทขึ้นไป
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Overview",
  data(){
    return{
      results: {
        sharePercent:"0",
        totalIncome: 0.0,
        currentIncome: 0.0,
        memberReferCount: 0.0,
        referTransactionAmount: 0.0,
        memberReferClick: 0.0,
        memberReferUrl: "",
        marketingEmail: ""
      }
    };
  },
  mounted() {
    this.getResult();
  },
  methods: {
    fbsClick() {
      const u = this.results.memberReferUrl;
      const t = document.title;
      window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(this.results.memberReferUrl)+'&t='+encodeURIComponent(t),'sharer','toolbar=0,status=0,width=626,height=436');return false;
    },
    lineClick() {
      const u = this.results.memberReferUrl;
      const t = document.title;
      window.open('https://social-plugins.line.me/lineit/share?url='+encodeURIComponent(this.results.memberReferUrl),'sharer','toolbar=0,status=0,width=626,height=436');return false;
    },
    getResult() {
      axios.post(this.getApiUrl + "/affiliate/overview",
        {
          CustomerCode: this.getUsername,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        })
        .then(response => {
          this.results = response.data.data;
          console.log('results', this.results);
        });
    },
    onCopy: function(e) {
      this.$bvToast.toast("คัดลอกลิงค์แนะนำเรียบร้อยแล้ว", {
        title: `สำเร็จ`,
        variant: "success",
        //solid: true,
        autoHideDelay: 3000
      });
    },
    onError: function(e) {
      console.log("Failed to copy texts");
    }    
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  },
  watch: {

  }  
};
</script>

<style lang="scss" scoped>
</style>